<template>
    <DataTable
            v-redirect-if-no-permission:SERVICES
            v-if="name" :url="api.ACTIONS.SERVICE_CARS(id)"
            descending
            :titles="titles"
            :title="$t('settings.cars.attachedCars', { name })"
            :enable-edit="false"
            :enable-delete="false"
            :fields-hidden-main="['color_id', 'car_document', 'insurance_document', 'car_brand_id','brand_model_id','approved','deny_reason', 'pivot', 'deleted_at', 'captain_id']"
            :fields-hidden-add="['id','captain','brand', 'car_brand_id','model','color','insurance_expired_date','car_manufacture_year','number','insurance_document',
               'car_document','captain_id','color_id','brand_model_id','approved','deny_reason','deleted_at','created_at','updated_at','pivot']"
            :fields-extra-add="fieldsExtraAdd"
            :selected-actions="selectedActions"
            :selectable="'Select'"
            :formatter="formatter"
    ></DataTable>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "ServiceCars",
        title() {
            return this.$t('settings.cars.title');
        },
        components: {DataTable},
        data() {
            return {
                id: null,
                name: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || this.$t("settings.cars.unknown");
        },
        computed: {
            formatter() {
                const api = this.api;
                const unloadable = this.$t("settings.cars.unloadable");
                return {
                    insurance_document(value) {
                        if (value == null) return unloadable;
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" style="width: 75px" class="img-thumbnail"/>`;
                    },
                    car_document(value) {
                        if (value == null) return unloadable;
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" style="width: 75px" class="img-thumbnail"/>`;
                    },
                    created_at: (val) => this.moment(val).format('MMM DD YYYY'),
                    updated_at: (val) => this.moment(val).format('MMM DD YYYY')
                }
            },
            titles() {
                return {
                    id: "#",
                    cars: this.$t("settings.cars.captainsToAdd"),
                    car_manufacture_year: this.$t('settings.cars.manuYear'),
                    insurance_expired_date: this.$t('settings.cars.insExpired')
                }
            },
            fieldsExtraAdd() {
                return {
                    cars: "choose-cars"
                }
            },
            selectedActions() {
                return {
                    "Delete": {
                        color: "error",
                        title: this.$t("common.delete"),
                        do: async (items) => {
                            try {
                                let params = new URLSearchParams();
                                let index = 0;
                                for (let item of items) params.append("cars[" + (index++) + "]", item.id);
                                await this.axios.delete(this.api.ACTIONS.SERVICES + "/" + this.id + "/cars?" + params.toString());
                                window.getApp.$emit("SHOW_TOAST", this.$t("settings.cars.deleted"), "green");
                                return {
                                    shouldClearSelected: true,
                                    shouldReloadData: true
                                }
                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", this.$t("settings.cars.failed"), "red");
                            }

                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>